import { render, staticRenderFns } from "./lamsRegLegalDocReview.vue?vue&type=template&id=76c5a287&scoped=true&"
import script from "./lamsRegLegalDocReview.vue?vue&type=script&lang=js&"
export * from "./lamsRegLegalDocReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c5a287",
  null
  
)

export default component.exports